import { Injectable } from "@angular/core";
import { DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase, getDefaultColumnStyle } from "@devwareapps/devware-cap";
import { CodeValuePermitType, PermitRequestEntity, PermitsMetaDataItemNames } from "../meta-data/permits-meta-data.service";
import { PermitRequestService } from '../services/permit-request.service';
//import { _ } from 'lodash';

@DwGridColumn({
    keyName: 'permit-request-permit-type-column',
    display: 'Permit request - Permit Types',
    decoratorType: DwDecoratorType.service,
    isGlobal: false,
    parentItemName:  PermitsMetaDataItemNames.PermitRequest,
    allowAttr: false,
    requireAttr: false,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Injectable()
export class PermitRequestPermitTypeColumnService implements DwGridColumnRendererBase {
   
    renderColumn(columnConfig: DwGridColumnDef<any>): (params: DwColumnRendererParams) => any {
        return (params) => {
            const data: PermitRequestEntity = params.data;
            if (!data) return "";

            const types = data.PermitRequestPermitType?.map(pt => pt.PermitTypeCvDisplay) || [];

            return types.join(", ");
        }
    }
}